import { Outlet, useNavigation } from "react-router-dom"

import Navbar from "./Navbar"

import Sidebar from "./Sidebar"

import Footer from "./Footer"

import Loader from "./loader/Loader"

import { useEffect, useRef } from "react"

import { useDispatch, useSelector } from "react-redux"

import { clearUser, setUser, trackLogout } from "../analytics/analytics"

import { fetchBusinessDetails } from "../store/profileSlice"

import { fetchCurrentPlan } from "../store/planSlice"



export default function Root() {

    const navigation = useNavigation()

    const dispatch = useDispatch()



    const user = useSelector(state => state.auth.user)
    const previousUidRef = useRef(user?.uid);

    useEffect(() => {
        dispatch(fetchBusinessDetails());
    }, [dispatch, user]);



    useEffect(() => {

        if (user) {

            dispatch(fetchCurrentPlan());

        }

    }, [dispatch, user]);



    useEffect(() => {
        const uid = user?.uid ?? null;
        const previousUid = previousUidRef.current ?? null;

        if (uid) {
            setUser(uid);
        } else if (previousUid) {
            trackLogout();
        } else {
            clearUser();
        }

        previousUidRef.current = uid;
    }, [user?.uid]);



    return (
        <div className="flex min-h-dvh flex-col md:h-screen md:min-h-0 md:overflow-hidden">
            <Navbar />

            <Loader isLoading={navigation.state === "loading"} />

            <div className="main-layout flex w-full min-h-0 flex-1 flex-row overflow-x-hidden md:overflow-hidden">
                <Sidebar />

                <div className="content relative z-0 min-h-0 min-w-0 flex-1 bg-transparent p-0">
                    <div className="no-scrollbar min-h-0 flex-1 overflow-x-hidden overflow-y-auto bg-white px-3 py-4 max-md:pt-14 md:px-10 md:py-8">
                        <div className="relative z-10 mx-auto min-h-[84vh] w-full min-w-0 max-w-7xl pt-8 md:pt-0">
                            <Outlet />
                        </div>

                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
}


